import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'assets/Icon';
import Card from '../Card';
import styles from './style/linkCard.module.css';

const LinkCard = ({
  href,
  icon,
  label,
}) => (
  <Card elevation="2-4">
    <Link to={href} className={styles.linkCard}>
      <div className={styles.linkCard__icon}>
        <Icon fill="white" icon={icon} size={32} />
      </div>
      <h3 className="display6">{ label }</h3>
    </Link>
  </Card>
);

export default LinkCard;
